"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagPtIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagPtIcon = (0, _mobxReact.observer)(_class = (_FlagPtIcon = /*#__PURE__*/function (_React$Component) {
  function FlagPtIcon() {
    _classCallCheck(this, FlagPtIcon);
    return _callSuper(this, FlagPtIcon, arguments);
  }
  _inherits(FlagPtIcon, _React$Component);
  return _createClass(FlagPtIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 101"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fillRule: "nonzero",
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#13AB5E",
        d: "M0 .1h100v100H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF5252",
        d: "M49.8.1h50v100h-50z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF3",
        d: "M49.7 26h2v47.7h-2z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF3",
        d: "M74.618 48.843v2h-47.7v-2z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF3",
        d: "M34.023 32.795l1.49-1.335 31.84 35.518-1.49 1.335z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF3",
        d: "M66.89 32.26l1.414 1.414-33.73 33.73-1.414-1.415z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M50.9 74c-13.5 0-24.5-11-24.5-24.5S37.4 25 50.9 25s24.5 11 24.5 24.5S64.4 74 50.9 74zm0-47c-12.4 0-22.5 10.1-22.5 22.5S38.5 72 50.9 72s22.5-10.1 22.5-22.5S63.3 27 50.9 27z",
        fill: "#FF3"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M58.7 41.7v10.4c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8V41.7h15.6m2.6-5.2H40.4c-1.4 0-2.6 1.2-2.6 2.6v13.1c0 7.2 5.8 13.1 13.1 13.1S64 59.5 64 52.2V39.1c-.1-1.5-1.2-2.6-2.7-2.6z",
        fill: "#FF5252"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M50.9 65.7c-7.5 0-13.6-6.1-13.6-13.6v-13c0-1.7 1.4-3.1 3.1-3.1h20.9c1.7 0 3.1 1.4 3.1 3.1v13.1c0 7.4-6 13.5-13.5 13.5zM40.4 37c-1.2 0-2.1.9-2.1 2.1v13.1c0 6.9 5.6 12.6 12.6 12.6s12.6-5.6 12.6-12.6V39.1c0-1.2-.9-2.1-2.1-2.1h-21zm10.5 23.5c-4.6 0-8.3-3.7-8.3-8.3v-11h16.7v10.9c-.1 4.6-3.8 8.4-8.4 8.4zm-7.3-18.3v9.9c0 4 3.3 7.3 7.3 7.3s7.3-3.3 7.3-7.3v-9.9H43.6z",
        fill: "#000"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M58.7 41.7v10.4c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8V41.7h15.6",
        fill: "#F5F5F5"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        fill: "#0000DC"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M52.6 48.9v2.2c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-2.2h3.4M52.6 43.5v2.2c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-2.2h3.4M52.6 54.3v2.2c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-2.2h3.4M57.1 48.9v2.2c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-2.2h3.4M48 48.9v2.2c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-2.2H48"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        fill: "#FF3"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M49.4 37.7h2.8v3h-2.8zM39 37.7h2.8v3H39zM59.9 37.7h2.8v3h-2.8zM39 48h2.8v3H39zM59.8 48h2.8v3h-2.8zM57.2 57.8H60v3h-2.8zM41.7 57.8h2.8v3h-2.8z"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagPtIcon.defaultProps = {
  width: '20px'
}, _FlagPtIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagPtIcon);